import {i18n} from '@yourcoach/i18n';

import type {TrackerSlug} from '../../../modules/food-diary/stores/types';

export const getFoodDiaryTrackerTitle = (slug?: TrackerSlug): string => {
  /**
   * @i18n_parser
   * t('shared:food_diary.nutrients_title.added_sugars')
   * t('shared:food_diary.nutrients_title.calcium')
   * t('shared:food_diary.nutrients_title.calories')
   * t('shared:food_diary.nutrients_title.carbohydrate')
   * t('shared:food_diary.nutrients_title.cholesterol')
   * t('shared:food_diary.nutrients_title.fat')
   * t('shared:food_diary.nutrients_title.fiber')
   * t('shared:food_diary.nutrients_title.iron')
   * t('shared:food_diary.nutrients_title.monounsaturated_fat')
   * t('shared:food_diary.nutrients_title.polyunsaturated_fat')
   * t('shared:food_diary.nutrients_title.potassium')
   * t('shared:food_diary.nutrients_title.protein')
   * t('shared:food_diary.nutrients_title.saturated_fat')
   * t('shared:food_diary.nutrients_title.sodium')
   * t('shared:food_diary.nutrients_title.sugar')
   * t('shared:food_diary.nutrients_title.trans_fat')
   * t('shared:food_diary.nutrients_title.vitamin_a')
   * t('shared:food_diary.nutrients_title.vitamin_c')
   * t('shared:food_diary.nutrients_title.vitamin_d')
   */
  return slug ? i18n.t(`shared:food_diary.nutrients_title.${slug}`) : '';
};
